import { Vue, Component } from 'vue-property-decorator';
import GoogleMaterialIcon from '../icons/google-material-icon/google-material-icon';
import { SCHOOLS_SIGN_UP } from '@/utils/constants';
import StaticAssetsMixin from '@/helpers/mixins/static-assets-mixin';

@Component({
    name: 'guest-user-pop',
    components: {
        'materail-icons': GoogleMaterialIcon,
    },
})

export default class GuestUserPop extends Vue {

    // ---------------------------------------------------------------------------------
    // Properties

    // ---------------------------------------------------------------------------------
    // Hooks

    // ----------------------------------------------------------------------------------
    // Actions
    public get logo() {
        const isMygooru = new StaticAssetsMixin().isMygooruHost();
        return isMygooru ? 'mygooru-ai' : 'logo';
    }
    private onSignUp() {
       window.open(SCHOOLS_SIGN_UP);
    }

    private onClosePop() {
        this.$emit('onClosePop');
    }

    // ---------------------------------------------------------------------------------
    // Methods

}
